import { render, staticRenderFns } from "./AccountActivityTab.vue?vue&type=template&id=548dd5b9"
import script from "./AccountActivityTab.vue?vue&type=script&lang=js"
export * from "./AccountActivityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports